import React, { Children, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import styles from './styles.module.css'
import { addCountryToWishlistSync, removeCountryFromWishlistSync } from '../WishListComponent/reducer';
import { addCountryToVisitedWithSync } from '../VisitedListComponent/reducer';
import { COUNTRY_INFO, COUNTRY_NAMES } from '../../constans/countries/countries';
import { Link } from 'react-router-dom';
import { TicketLink } from '../TicketLink';
import { InfoWeather } from '../InfoWeather/InfoWeather';
import { countries_descriptions } from '../../constans/countries/countries_description';
import { ReactComponent as Passport } from './svg/passport.svg';
import { ReactComponent as Plane } from './svg/plane8.svg';
import { ReactComponent as City } from './svg/city.svg';
import { ReactComponent as Calendar } from './svg/calendar.svg';
import { ReactComponent as Hotel } from './svg/hotel.svg';
import { ReactComponent as Location } from './svg/location.svg';
import { ReactComponent as Checked } from './svg/checked.svg';
import { ReactComponent as Highlights } from './svg/highlights.svg';
import { ReactComponent as Language } from './svg/language.svg';
import { ReactComponent as Bed } from './svg/bed.svg';
import { getVisaInfo } from '../../constans/functions/visaServices';
import { getCurrentLocation } from '../../constans/functions/locationService';
import { getDepartureLocation, getRoute } from '../../constans/functions/flightService';
import { findNearestAirport } from 'airport-data-js';


export const ModalButtonContainer = ({ children }) => {

    const dispatch = useDispatch();
    const [isAnimating, setIsAnimating] = useState(false);
    const [visaInfo, setVisaInfo] = useState(null);
    const countryIndex = COUNTRY_NAMES.indexOf(children.name);
    const TRIP_URL = "https://www.trip.com/";
    const [flightLink, setFlightLink] = useState(TRIP_URL);


    // MAKE LOADER!!! set info styles when loading or visited/liked 

    const [wishClassNames, setWishClassNames] = useState(
        children.wish ? styles.wish : styles.notwish);
    const [visitedClassNames, setVisitedClassNames] = useState(
        children.visited ? styles.visited : styles.notvisited);  
        
    const meta = useSelector(
        state => state.visitedList?.visitMeta?.[countryIndex]
    );

    const passportData = useSelector(
        state => state.settings.passport
    );

    const passport = COUNTRY_INFO[passportData]?.name;
    const passportISO2 = COUNTRY_INFO[passportData]?.iso2;
    
    useEffect(() => {
        if (!passportISO2 || !children.iso2) {
            setVisaInfo(null);
            return;
        }
    
        const loadVisa = async () => {
            try {
                const info = await getVisaInfo(
                    passportISO2,
                    children.iso2
                );
                setVisaInfo(info);
            } catch (error) {
                setVisaInfo(null);
            }
        };
        loadVisa();
    }, [passportISO2, children.iso2]);

    const getVisaClass = () => {
        if (!passport) {
            return styles.visa_default_item;
        }
    
        switch (visaInfo?.requirement) {
            case 'visa_free':
                return styles.visa_free_item;
    
            case 'evisa':
                return styles.visa_evisa_item;

            case 'eta':
                return styles.visa_evisa_item;
    
            case 'visa_on_arrival':
                return styles.visa_arrival_item;
    
            case 'visa_required':
                return styles.visa_required_item;
    
            default:
                return styles.visa_default_item;
        }
    };

    // VISA INFO FROM doineedvisa.com 

    // const API_KEY = process.env.REACT_APP_VISA_INFO_API_KEY;

    // const getVisaInfo = async () => {
    //     const response = await fetch(
    //         `https://visa.orizn.app/api/v1/visa/check?passport=${passportISO3}&destination=${children.iso3}`,
    //         {
    //             headers: {
    //                 'x-api-key': API_KEY
    //             }
    //         }
    //     );
    
    //     const data = await response.json();
    //     setVisaInfo(data);
    // };

    // useEffect(() => {
    //     if (passport && children.iso3) {
    //         getVisaInfo();
    //     }
    // }, [passport, children]);

    useEffect(() => {
        let cancelled = false;
    
        const loadFlightLink = async () => {
            try {
                const link = await getRoute(children.capital, passport);
    
                if (!cancelled) {
                    setFlightLink(link);
                }
            } catch (error) {
                console.error(error);
    
                if (!cancelled) {
                    setFlightLink(TRIP_URL);
                }
            }
        };
    
        loadFlightLink();
    
        return () => {
            cancelled = true;
        };
    }, [children.capital, passport]);

    const hasTripDetails =
        Boolean(meta?.note?.trim()) ||
        Boolean(meta?.visitedYear && meta?.visitedMonth) ||
        Boolean(meta?.status);

    function addToWish () {
        if (!children.wish) {
            setIsAnimating(true);
            dispatch(addCountryToWishlistSync(COUNTRY_NAMES.indexOf(children.name)));
            setWishClassNames(styles.wish);
            setTimeout(() => {
                setIsAnimating(false);
            }, 600);
        } else {
            dispatch(removeCountryFromWishlistSync(COUNTRY_NAMES.indexOf(children.name)));
            setWishClassNames(styles.notwish);
        }
    }

    function addToVisited () {
        dispatch(addCountryToVisitedWithSync(COUNTRY_NAMES.indexOf(children.name)))
        dispatch(removeCountryFromWishlistSync(COUNTRY_NAMES.indexOf(children.name))); 
        setWishClassNames(styles.notwish);
        setIsAnimating(false);
        setVisitedClassNames(styles.visited)
    }

    const flightPrice = '$160';
    const hotelPrice = '$80';
    
    return (
    <div className={styles.root}>
        <div className={styles.modalName}>{children.name}</div>
        <div className={styles.rootRegion}>
            <Location className={styles.svg_location}/> {COUNTRY_INFO[countryIndex].region}
        </div>
        <div className={styles.rootWhy}>
                    &ldquo;{countries_descriptions[COUNTRY_INFO[countryIndex].name].why_visit}&rdquo;
            </div>
                <div className={styles.actionButtons}>
                    {!children.visited && (
                        <div className={styles.rootWish}>
                            <div 
                                className={`${styles.wishWrapper} ${children.wish ? styles.active : ''}`}
                                onClick={addToWish}>
                                <div
                                    className={`${wishClassNames} ${isAnimating ? styles.animating : ''}`}
                                    title={children.wish ? 'Remove from wishlist' : 'Add to wishlist'}>
                                    {children.wish ? '\u2665' : '\u2661'}
                                </div>
                                {children.wish ? (
                                    <>
                                        <Link 
                                            to='/wishlist' 
                                            className={styles.wishlistLink}
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            <span>In wishlist</span>
                                            <span className={styles.arrow_icon}>→</span>
                                        </Link>
                                        
                                    </>
                                ) : (
                                    <span className={styles.wishText}>Wish</span>
                                )}
                            </div>
                        </div>
                    )}
                    <div className={`${styles.rootAdd} ${children.visited ? styles.rootAddFull : ''}`}
                        onClick={!children.visited ? addToVisited : undefined}>
                        {children.visited ? (
                            <div className={styles.visitedContent}>
                                <Checked className={styles.checkedIcon} />
                                <div className={styles.visitedTextContainer}>
                                    <div className={styles.visitedTitle}>You've been here</div>
                                    <div className={styles.visitedSubtext}>
                                        {hasTripDetails ? (
                                            'View your trip details and memories'
                                        ) : (
                                            'Add trip details to remember your journey'
                                        )}
                                    </div>
                                </div>
                                <button className={styles.tripDetailsButton}>
                                    {hasTripDetails ? 
                                        <Link to='/visited'>View trip details 
                                            <span className={styles.arrow_wide_icon}>→</span>
                                        </Link> : 
                                        <Link to='/visited'>Add trip details 
                                            <span className={styles.arrow_wide_icon}>→</span>
                                        </Link>
                                    }
                                </button>
                            </div>
                        ) : (
                            <>
                                <Checked className={styles.checkIcon} />
                                <div
                                className={visitedClassNames}
                                // onClick={addToVisited}
                                title='I have been here'>
                                Visited
                                </div>
                            </>
                            
                        )}
                    </div>
                </div>   
                <div className={styles.infobar}>
                <span
                    className={`${styles.infobar_item_1} ${getVisaClass()}`}>
                    <Passport className={styles.svg_icon}/>

                    {!passport ? (
                        <span className={styles.infobar_content}>
                            <span className={styles.infobar_label}>
                                Visa info
                            </span>

                            <Link
                                to="/settings"
                                className={styles.set_passport_link}
                                onClick={(e) => e.stopPropagation()}
                            >
                                Set passport
                                <span className={styles.highlightArrow}>↗</span>
                            </Link>
                        </span>
                    ) : (
                        <span className={styles.infobar_content}>
                            <span className={styles.infobar_value}>

                                {visaInfo?.requirement === 'visa_free' && (
                                    <span className={styles.visa_status_container}>
                                        <span className={styles.visa_status}>
                                            Visa-free
                                        </span>

                                        {visaInfo.max_stay_days && (
                                            <span className={styles.visa_subtext}>
                                                Up to {visaInfo.max_stay_days} days
                                            </span>
                                        )}
                                    </span>
                                )}

                                {visaInfo?.requirement === 'evisa' && (
                                    <span className={styles.visa_status_container}>
                                        <span className={styles.visa_status}>
                                            eVisa
                                        </span>
                                        <span className={styles.visa_subtext}>
                                            Apply online
                                        </span>
                                    </span>
                                )}

                                {visaInfo?.requirement === 'eta' && (
                                    <span className={styles.visa_status_container}>
                                        <span className={styles.visa_status}>
                                            Electronic Travel Authorization
                                        </span>

                                        <span className={styles.visa_subtext}>
                                            Apply online
                                        </span>
                                    </span>
                                )}

                                {visaInfo?.requirement === 'visa_on_arrival' && (
                                    <span className={styles.visa_status_container}>
                                        <span className={styles.visa_status}>
                                            Visa on arrival
                                        </span>

                                        <span className={styles.visa_subtext}>
                                            Get it on arrival
                                        </span>
                                    </span>
                                )}

                                {visaInfo?.requirement === 'visa_required' && (
                                    <span className={styles.visa_status_container}>
                                        <span className={styles.visa_status}>
                                            Visa required
                                        </span>

                                        <span className={styles.visa_subtext}>
                                            Check requirements
                                        </span>
                                    </span>
                                )}

                                {visaInfo?.requirement === undefined && (
                                    <span className={styles.visa_status_container}>
                                        <span className={styles.visa_status}>
                                            Visa info unavailable
                                        </span>
                                    </span>
                                )}

                            </span>
                        </span>
                    )}
                </span>
                    <span className={styles.infobar_item_2}>
                        <Calendar className={styles.svg_icon}/>
                        <span className={styles.infobar_content}>
                            <span className={styles.infobar_label}>Best time</span>
                            <span className={styles.infobar_value}>
                                {countries_descriptions[COUNTRY_INFO[countryIndex].name].best_time}
                            </span>
                        </span>
                    </span>
                    <span className={`${styles.infobar_item_3} ${styles.infobar_weather}`}>
                        <InfoWeather country_capital={COUNTRY_INFO[countryIndex].capital} />
                    </span>
                    <span className={styles.infobar_item_4}>
                        <City className={styles.svg_icon}/>
                        <span className={styles.infobar_content}>
                            <span className={styles.infobar_label}>Capital</span>
                            <span className={styles.infobar_value}
                                  title={COUNTRY_INFO[countryIndex].capital}>
                                {COUNTRY_INFO[countryIndex].capital}
                            </span>
                        </span>
                    </span>
                    <span className={styles.infobar_item_5}>
                        <Language className={styles.svg_icon}/>
                        <span className={styles.infobar_content}>
                            <span className={styles.infobar_label}>Language</span>
                            <span className={styles.infobar_value}
                                  title={countries_descriptions[COUNTRY_INFO[countryIndex].name].language}>
                                {countries_descriptions[COUNTRY_INFO[countryIndex].name].language}
                            </span>
                        </span>
                    </span>
                    <span className={styles.infobar_item_6}>
                        <Highlights className={styles.svg_icon_highlight}/>
                        <span className={styles.infobar_content}>
                            <span className={styles.infobar_value}>
                                {countries_descriptions[COUNTRY_INFO[countryIndex].name].highlights.map(
                                    (e, i) => 
                                        <a key={i}
                                            className={styles.highlights_bullits}
                                            href={`https://www.google.com/search?tbm=isch&q=${encodeURIComponent(`${e} ${COUNTRY_INFO[countryIndex].name}`)}`}
                                            target="_blank"
                                            rel="noopener noreferrer">
                                                {e}
                                            <span className={styles.highlightArrow}>↗</span>
                                        </a>
                                        
                                )}</span>
                            </span>
                    </span>
                </div>
                <a 
                    className={styles.infobar_flights}
                    href={flightLink}
                    target="_blank"
                    rel="noopener noreferrer">
                    <Plane className={styles.svg_icon_wide}/>
                    <span className={styles.infobar_content}> 
                        <span className={styles.infobar_label_wide}>
                            Buy tickets
                        </span>
                        <span className={styles.infobar_link}>
                            <span className={styles.infobar_value_wide}>
                                Find the best deals on Trip.com 
                            </span>
                            <span className={styles.arrow_visited_icon}>→</span>
                        </span>
                    </span>
                </a>
                <a 
                    className={styles.infobar_hotels}
                    href='https://www.trip.com/hotels'
                    target="_blank"
                    rel="noopener noreferrer">
                    <Bed className={styles.svg_icon_wide}/>
                    <span className={styles.infobar_content}>
                        <span className={styles.infobar_label_wide}>
                            Book hotels
                        </span>
                        <span className={styles.infobar_link}>
                            <span className={styles.infobar_value_wide}>
                                Find the best stays on Trip.com
                            </span>
                            <span className={styles.arrow_visited_icon}>→</span>
                        </span>
                        
                    </span>
                </a>
                <div className={styles.infobar_message}>
                    {!children.wish && !children.visited && (
                        <div>
                            Add this country to your wish list or mark it as visited
                        </div>
                    )}
                    {children.wish && !children.visited && (
                         <>
                            <div>
                                <strong>{COUNTRY_INFO[countryIndex].name}</strong> is in your wishlist.
                            </div>
                            <div>
                                Start planning your trip from your wishlist page
                            </div>
                        </>
                    )}
                    {children.visited && (
                    hasTripDetails ? (
                        <>
                            <div>
                                You've visited <strong>{COUNTRY_INFO[countryIndex].name}</strong>.
                            </div>
                            <div>
                                View or update your trip notes, dates and memories
                            </div>
                        </>
                    ) : (
                        <>
                            <div>
                                <strong>{COUNTRY_INFO[countryIndex].name}</strong> has been added to your visited countries.
                            </div>
                            <div>
                                Add your travel dates, notes and memories
                            </div>
                        </>
                    )
                )}
        </div>
    </div>
  )
}
